import { render, staticRenderFns } from "./PermitsV1.vue?vue&type=template&id=051ee382&scoped=true&"
import script from "./PermitsV1.vue?vue&type=script&lang=js&"
export * from "./PermitsV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ee382",
  null
  
)

export default component.exports